// @ts-nocheck
import React from 'react';
import Tooltip from '../../ui/Tooltip';

interface SliderConfig {
  min: number;
  max: number;
  step: number;
  unit?: string;
}

interface DynamicSliderProps {
  fieldId: string;
  label: string;
  description?: string;
  tooltip?: string;
  value: number;
  onChange: (value: number) => void;
  config: SliderConfig;
  isRequired?: boolean;
  error?: string;
}

export default function DynamicSlider({
  fieldId,
  label,
  description,
  tooltip,
  value,
  onChange,
  config,
  isRequired,
  error
}: DynamicSliderProps) {
  const displayValue = config.unit ? `${value}${config.unit}` : value.toString();
  
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label htmlFor={fieldId} className="text-xs font-medium text-gray-300">
          {label}
          {isRequired && <span className="text-red-400 ml-1">*</span>}
        </label>
        {tooltip && (
          <Tooltip content={tooltip}>
            <div className="w-4 h-4 bg-gray-700/50 border border-gray-600 rounded-full flex items-center justify-center cursor-help hover:bg-gray-600/50 transition-colors duration-200">
              <span className="text-xs text-gray-300 font-medium">?</span>
            </div>
          </Tooltip>
        )}
      </div>
      
      {description && (
        <p className="text-xs text-gray-400">{description}</p>
      )}
      
      <div className="space-y-2">
        <input
          type="range"
          id={fieldId}
          min={config.min}
          max={config.max}
          step={config.step}
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value))}
          className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider"
        />
        <div className="flex justify-between text-xs text-gray-400">
          <span>{config.min}{config.unit || ''}</span>
          <span className="font-medium text-white">{displayValue}</span>
          <span>{config.max}{config.unit || ''}</span>
        </div>
      </div>
      
      {error && (
        <p className="text-xs text-red-400">{error}</p>
      )}
    </div>
  );
}